// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-post-deck {
  display: flex; /* Ensures flexbox layout for internal elements */
  flex-wrap: wrap; /* Allows items to wrap to next line */
  justify-content: space-around; /* Evenly spaces the child elements */
  flex: 1 1; /* Takes up available space */
  background: #2a2a2a;
  padding: 20px;
  min-width: 55%;
  width: 60%;  
  transition: all 0.3s ease;
  position: relative;
  height: auto; /* Adjust height dynamically */
  border-radius: 0px 0px 10px 0px;
  margin-right: 5px;
}


/* 
.location-post-deck.collapsed {
  min-width: 50px;
  max-width: 50px;
  padding: 10px;
} */

.location-post-deck h2 {
  position: sticky;
  color: #65ccb7;
  margin-bottom: 20px;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -6%;
}

/* .location-toggle-btn {
  position: sticky;
  background: transparent;
  border: none;
  color: #65ccb7;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
} */

/* .location-toggle-btn:hover {
  transform: scale(1.1);
} */

.location-posts-container {
  
  display: flex;
  /* grid-template-columns: repeat(3,1fr); */
  flex-wrap: wrap; /* Allow items to wrap to the next line */
  gap: 20px; /* Provides space between cards */
  height: 72vh; /* Adjust if necessary to fit the container height */
  overflow-y: auto; /* Allows scrolling within the container */
  padding-right: 10px; /* Adjust padding as necessary */
  justify-content: left;
}

.location-post-card {
  height: fit-content;
  flex: 1 1 48%; /* Each card takes up roughly 48% of the container width */
  max-width: 45%; /* Ensures that the card does not exceed 48% width */
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 20px; /* Space at the bottom of each card */
  background-color: #fff; /* Assuming cards have a white background */
  box-shadow: 0 2px 5px rgba(0,0,0,0.1); /* Optional: adds shadow for better visibility */
}

@media (max-width: 768px) {
  .location-post-card {
    flex: 0 0 100%; /* On smaller screens, each card takes full width */
    max-width: 100%;
  }
}



.location-post-card:hover {
  transform: translateY(-2px);
}

.location-post-card.twitter {
  background: rgba(29, 161, 242, 0.1);
  border: 1px solid rgba(29, 161, 242, 0.2);
}

.location-post-card.instagram {
  background: linear-gradient(45deg, rgba(405, 0, 87, 0.1), rgba(188, 42, 141, 0.1));
  border: 1px solid rgba(188, 42, 141, 0.2);
}

.location-post-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}

.location-user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #65ccb7;
}

.location-user-info {
  flex: 1 1;
}

.location-user-info h4 {
  margin: 0;
  color: #65ccb7;
  font-size: 1rem;
}

.location-user-info span {
  display: block;
  font-size: 0.8em;
  color: #888;
}

.location-location {
  color: #65ccb7 !important;
  font-style: italic;
}

.location-post-content {
  margin: 10px 0;
  line-height: 1.4;
  height: 60px; /* Limit the initial height */
  overflow: hidden; /* Hide content beyond the limit */
  transition: height 0.3s ease; /* Smooth transition */
  text-align: justify;
}

.location-post-content.expanded {
  height: auto; /* Allow content to expand fully */
}

.location-read-more {
  color: #65ccb7;
  cursor: pointer;
  font-size: 0.9rem;
  text-align: right;
  margin-top: 10px;
  display: block;
}
.location-post-image {
  width: 100%;
  border-radius: 8px;
  margin-top: 10px;
}

.location-post-footer {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.location-platform-tag {
  font-size: 0.8em;
  padding: 4px 8px;
  border-radius: 5px;
  background: #65ccb7;
  color: white;
  display: flex;
  align-items: center;
  gap: 5px;
}

.location-loading {
  grid-column: span 2;
  text-align: center;
  color: #65ccb7;
  padding: 20px;
  font-style: italic;
}

@keyframes location-slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .location-post-deck {
    min-width: 100%;
    max-width: 100%;
    height: 50vh;
  }

  .location-post-deck.collapsed {
    height: 50px;
    min-width: 100%;
    max-width: 100%;
  }
}

.post-search-container {
  padding: 10px;
}
.post-search-input {
  position: sticky;
  width: 100%;
  padding: 8px;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid #65ccb7;
  background: #3a3a3a;
  color: white;
}


.highlight {
  background-color: yellow; /* Highlight color */
  color: black; /* Text color */
}

.location-post-content {
  word-wrap: break-word; /* Ensures text wraps and does not overflow */
  overflow-wrap: break-word; /* Alternative to word-wrap */
}
`, "",{"version":3,"sources":["webpack://./src/globe/components/PostDeck/PostDeck.css"],"names":[],"mappings":"AAAA;EACE,aAAa,EAAE,iDAAiD;EAChE,eAAe,EAAE,sCAAsC;EACvD,6BAA6B,EAAE,qCAAqC;EACpE,SAAO,EAAE,6BAA6B;EACtC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,YAAY,EAAE,8BAA8B;EAC5C,+BAA+B;EAC/B,iBAAiB;AACnB;;;AAGA;;;;;GAKG;;AAEH;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;;;;;;;;;;GAWG;;AAEH;;GAEG;;AAEH;;EAEE,aAAa;EACb,0CAA0C;EAC1C,eAAe,EAAE,yCAAyC;EAC1D,SAAS,EAAE,iCAAiC;EAC5C,YAAY,EAAE,oDAAoD;EAClE,gBAAgB,EAAE,0CAA0C;EAC5D,mBAAmB,EAAE,gCAAgC;EACrD,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa,EAAE,0DAA0D;EACzE,cAAc,EAAE,oDAAoD;EACpE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAE,qCAAqC;EAC1D,sBAAsB,EAAE,2CAA2C;EACnE,qCAAqC,EAAE,gDAAgD;AACzF;;AAEA;EACE;IACE,cAAc,EAAE,mDAAmD;IACnE,eAAe;EACjB;AACF;;;;AAIA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,kFAAkF;EAClF,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY,EAAE,6BAA6B;EAC3C,gBAAgB,EAAE,kCAAkC;EACpD,4BAA4B,EAAE,sBAAsB;EACpD,mBAAmB;AACrB;;AAEA;EACE,YAAY,EAAE,kCAAkC;AAClD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,wBAAwB,EAAE,oBAAoB;EAC9C,YAAY,EAAE,eAAe;AAC/B;;AAEA;EACE,qBAAqB,EAAE,6CAA6C;EACpE,yBAAyB,EAAE,6BAA6B;AAC1D","sourcesContent":[".location-post-deck {\n  display: flex; /* Ensures flexbox layout for internal elements */\n  flex-wrap: wrap; /* Allows items to wrap to next line */\n  justify-content: space-around; /* Evenly spaces the child elements */\n  flex: 1; /* Takes up available space */\n  background: #2a2a2a;\n  padding: 20px;\n  min-width: 55%;\n  width: 60%;  \n  transition: all 0.3s ease;\n  position: relative;\n  height: auto; /* Adjust height dynamically */\n  border-radius: 0px 0px 10px 0px;\n  margin-right: 5px;\n}\n\n\n/* \n.location-post-deck.collapsed {\n  min-width: 50px;\n  max-width: 50px;\n  padding: 10px;\n} */\n\n.location-post-deck h2 {\n  position: sticky;\n  color: #65ccb7;\n  margin-bottom: 20px;\n  font-size: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: -6%;\n}\n\n/* .location-toggle-btn {\n  position: sticky;\n  background: transparent;\n  border: none;\n  color: #65ccb7;\n  cursor: pointer;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.3s ease;\n} */\n\n/* .location-toggle-btn:hover {\n  transform: scale(1.1);\n} */\n\n.location-posts-container {\n  \n  display: flex;\n  /* grid-template-columns: repeat(3,1fr); */\n  flex-wrap: wrap; /* Allow items to wrap to the next line */\n  gap: 20px; /* Provides space between cards */\n  height: 72vh; /* Adjust if necessary to fit the container height */\n  overflow-y: auto; /* Allows scrolling within the container */\n  padding-right: 10px; /* Adjust padding as necessary */\n  justify-content: left;\n}\n\n.location-post-card {\n  height: fit-content;\n  flex: 1 1 48%; /* Each card takes up roughly 48% of the container width */\n  max-width: 45%; /* Ensures that the card does not exceed 48% width */\n  padding: 15px;\n  border-radius: 10px;\n  margin-bottom: 20px; /* Space at the bottom of each card */\n  background-color: #fff; /* Assuming cards have a white background */\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1); /* Optional: adds shadow for better visibility */\n}\n\n@media (max-width: 768px) {\n  .location-post-card {\n    flex: 0 0 100%; /* On smaller screens, each card takes full width */\n    max-width: 100%;\n  }\n}\n\n\n\n.location-post-card:hover {\n  transform: translateY(-2px);\n}\n\n.location-post-card.twitter {\n  background: rgba(29, 161, 242, 0.1);\n  border: 1px solid rgba(29, 161, 242, 0.2);\n}\n\n.location-post-card.instagram {\n  background: linear-gradient(45deg, rgba(405, 0, 87, 0.1), rgba(188, 42, 141, 0.1));\n  border: 1px solid rgba(188, 42, 141, 0.2);\n}\n\n.location-post-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.location-user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid #65ccb7;\n}\n\n.location-user-info {\n  flex: 1;\n}\n\n.location-user-info h4 {\n  margin: 0;\n  color: #65ccb7;\n  font-size: 1rem;\n}\n\n.location-user-info span {\n  display: block;\n  font-size: 0.8em;\n  color: #888;\n}\n\n.location-location {\n  color: #65ccb7 !important;\n  font-style: italic;\n}\n\n.location-post-content {\n  margin: 10px 0;\n  line-height: 1.4;\n  height: 60px; /* Limit the initial height */\n  overflow: hidden; /* Hide content beyond the limit */\n  transition: height 0.3s ease; /* Smooth transition */\n  text-align: justify;\n}\n\n.location-post-content.expanded {\n  height: auto; /* Allow content to expand fully */\n}\n\n.location-read-more {\n  color: #65ccb7;\n  cursor: pointer;\n  font-size: 0.9rem;\n  text-align: right;\n  margin-top: 10px;\n  display: block;\n}\n.location-post-image {\n  width: 100%;\n  border-radius: 8px;\n  margin-top: 10px;\n}\n\n.location-post-footer {\n  margin-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.location-platform-tag {\n  font-size: 0.8em;\n  padding: 4px 8px;\n  border-radius: 5px;\n  background: #65ccb7;\n  color: white;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.location-loading {\n  grid-column: span 2;\n  text-align: center;\n  color: #65ccb7;\n  padding: 20px;\n  font-style: italic;\n}\n\n@keyframes location-slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 768px) {\n  .location-post-deck {\n    min-width: 100%;\n    max-width: 100%;\n    height: 50vh;\n  }\n\n  .location-post-deck.collapsed {\n    height: 50px;\n    min-width: 100%;\n    max-width: 100%;\n  }\n}\n\n.post-search-container {\n  padding: 10px;\n}\n.post-search-input {\n  position: sticky;\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  border: 1px solid #65ccb7;\n  background: #3a3a3a;\n  color: white;\n}\n\n\n.highlight {\n  background-color: yellow; /* Highlight color */\n  color: black; /* Text color */\n}\n\n.location-post-content {\n  word-wrap: break-word; /* Ensures text wraps and does not overflow */\n  overflow-wrap: break-word; /* Alternative to word-wrap */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
